import { useNavigate } from "react-router-dom";
import logo from "../../assests/images/header/admin.png";
import { removeAuth } from "../utils/auth";

export default function Header({ user }) {
  const navigate = useNavigate();

  return (
    <>
      <div className="div-topheader">
        <div
          className="Table"
          style={{
            margin: "0px auto",
            float: "right",
            minWidth: "1024px",
            width: "100%",
          }}
        >
          <div className="Row" style={{ fontWeight: "bold" }}>
            <div
              className="Cell"
              style={{
                textAlign: "left",
                minWidth: "750px",
                paddingLeft: "30px",
              }}
            >
              <h4>www.marathamandaldombivli.org</h4>
            </div>
            {user && (
              <>
                <div className="Cell">
                  <label>Welcome {user.userName}</label>
                </div>
                <div className="Cell"></div>
                <div className="Cell">
                  <a
                    className="logout"
                    onClick={(e) => {
                      e.preventDefault();
                      //localStorage.removeItem("user");
                      removeAuth();
                      navigate("/admin/login");
                    }}
                  >
                    Logout
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="div-admin-topbanner">
        <div
          className="Table"
          style={{
            margin: "0px auto",
            minWidth: "1024px",
            height: "100%",
            padding: "0px",
          }}
        >
          <div className="Row">
            <div className="Cell" style={{ padding: "0px" }}>
              <img
                id="imgProfileLogo"
                src={logo}
                border="0"
                alt="Header Logo"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
